import type {SelectProps} from 'antd';
import {Checkbox, Menu, Select, Space} from 'antd';
import React, {useEffect, useState} from 'react';
import {ReactComponent as SelectArrayIcon} from '../../../../../../assets/i/select-array-icon.svg';
import {ReactComponent as ArrowUpIconIcon} from '../../../../../../assets/i/arrow-up-icon.svg';
import {ReactComponent as CloseFormIcon} from '../../../../../../assets/form/close-form.svg';
import {useAppDispatch, useAppSelector} from "common/hook";
import {loginActions} from "features/model/slice/lodinSlice";
import {setGroupIds} from "features/model/slice/create-test/create-test-form/createTestForm";


interface SelectModeGroupProps {
    onSelect: (selectedGroupIds: number[]) => void;
    onClearGroups: () => void;
    setSelectedGroupIds: (value: number[]) => void;
}

export const SelectModeGroup: React.FC<SelectModeGroupProps> = ({onSelect,onClearGroups,setSelectedGroupIds}) => {

    const {items, pagination, error, isLoading} = useAppSelector(state => state.groupsListing);

    const [value, setValue] = useState<number[]>([]);


    useEffect(() => {
        setSelectedGroupIds(value)
    }, [value]);

    useEffect(() => {
        if (value.length === 0) {
            onClearGroups();
        }
    }, [value]);


    const shouldAllowClear = value.length >= 2;


    const customClearIcon = (
        <CloseFormIcon/>
    );

    const options = items.map((item) => ({
        value: item.id,
        label: item.title,
    }));

    const [open, setOpen] = useState<boolean>(false);

    const selectProps: SelectProps = {
        mode: 'multiple',
        style: {width: '100%'},
        value,
        options,
        onChange: (newValue: number[]) => {
            setValue(newValue);
        },
        maxTagCount: 'responsive',
        onDropdownVisibleChange: (visible) => {
            setOpen(visible);
        },
        showSearch: true,
        dropdownRender: (menu) => (
            <Menu>
                {options.map((option) => (
                    <Menu.Item key={option.value}>
                        <Checkbox
                            checked={value.includes(option.value)}
                            onChange={() => {
                                const newValue = value.includes(option.value)
                                    ? value.filter((val) => val !== option.value)
                                    : [...value, option.value];
                                setValue(newValue);
                                onSelect(newValue);
                            }}
                            className="custom-checkbox"
                        >
                            {option.label}
                        </Checkbox>
                    </Menu.Item>
                ))}
            </Menu>
        ),
    };

    return (
        <div className="inp-box">
            <div id="select-mode">
                <Space direction="vertical" style={{width: '100%', cursor: 'pointer'}}>
                    <Select
                        {...selectProps}
                        allowClear={shouldAllowClear}
                        clearIcon={customClearIcon}
                        placeholder={<span className='placeholder-text'>Доступно группе/группам</span>}
                        className={`custom-select ${open ? 'custom-select-open' : 'custom-select-closed'}`}
                        suffixIcon={open ? <ArrowUpIconIcon/> : <SelectArrayIcon/>}
                    />
                </Space>
            </div>
        </div>
    );
};
